import { LoadingScreen } from 'app/agriculture/components/LoadingScreen';
import { FarmContextProvider } from 'app/agriculture/contexts/RequiredStartupProviders/FarmContext/FarmContextProvider';
import { ReactNode, Suspense } from 'react';

export function RequiredStartupProviders({ children }: { children: ReactNode }) {
    return (
        <Suspense fallback={<LoadingScreen />}>
            <FarmContextProvider>{children}</FarmContextProvider>
        </Suspense>
    );
}
